import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";
import { useLanguage } from "../../context/LanguageContext";
import dashboardContent from "../../utils/dashboardContent";

const SubscriptionOverlay = ({ onUpgrade, blur = true }) => {
  const { language } = useLanguage();
  const text = dashboardContent[language].subscriptionOverlay;
  const navigate = useNavigate();
  return (
    <div
      className={`relative inset-0 flex items-center justify-center z-10 ${
        blur ? "backdrop-blur-sm" : ""
      }`}
    >
      <div className="bg-white bg-opacity-90 p-4 rounded-lg shadow-lg text-center max-w-xs">
        <LockOutlined className="text-2xl text-yellow-500 mb-2" />
        <h3 className="text-lg font-semibold mb-2">{text.title}</h3>
        <p className="text-sm mb-4">{text.description}</p>
        <Button
          type="primary"
          size="small"
          onClick={() => navigate("/dashboard/abomanagement")}
          className="bg-blue-500 hover:bg-blue-600"
        >
          {text.upgradeButton}
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionOverlay;
